/**
 * Schermate della console con il «?» verso la Guida (PRD-006 US-1, PAGE-010), con il nome che il
 * pannello dell'aiuto mostra. Le chiavi sono le route del campo `schermate` del front-matter
 * (convenzioni in `docs/manuale/operatori/README.md`).
 */
export const HELP_SCREENS = {
  '/': 'Coda',
  '/archivio': 'Archivio',
  '/ticket/:codice': 'Dettaglio del ticket',
  '/posta-non-associata': 'Posta non associata',
  '/statistiche': 'Statistiche',
  '/impostazioni/team': 'Impostazioni › Team',
  '/impostazioni/coda': 'Impostazioni › Coda ed email',
  '/impostazioni/consumer': 'Impostazioni › Consumer',
  '/impostazioni/prodotti': 'Impostazioni › Prodotti',
  '/guida': 'Guida',
  '/profilo': 'Profilo',
} as const;

/** Una schermata con il «?». */
export type HelpScreen = keyof typeof HELP_SCREENS;

/**
 * Route ammesse nel campo `schermate`: quelle con il «?» più `/accesso` e `/autorizzazione-mcp`,
 * che stanno fuori dalla shell e quindi non hanno il «?», ma le cui pagine si trovano con la ricerca.
 */
export const GUIDE_ROUTES: readonly string[] = ['/accesso', '/autorizzazione-mcp', ...Object.keys(HELP_SCREENS)];

/** Vero se la route ha il «?». */
export function isHelpScreen(route: string): route is HelpScreen {
  return Object.hasOwn(HELP_SCREENS, route);
}
